var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:({
    mask: _vm.mask,
    masked: true,
    tokens: _vm.tokens
  }),expression:"{\n    mask: mask,\n    masked: true,\n    tokens: tokens\n  }"}],attrs:{"label":_vm.i18n(_vm.label),"outlined":_vm.outlined,"readonly":_vm.readonly,"autofocus":_vm.autofocus,"hide-details":_vm.hideDetails,"type":"tel"},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})
}
var staticRenderFns = []

export { render, staticRenderFns }